import textGuard from "et3-text-guard";
import { isDefinedString } from "et3-type-guards";

import { apiCallChangeUserName } from "../../../api/user-api/api-call-change-user-name";
import getCorePersonalStore from "../../core/core-personal-store";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";
import getUserAdvancedStore from ".";

const changeUsernameOnDatabase = async (userId: number) => {
  const newName = getUserAdvancedStore().changeUsernameInput.get();
  const oldName = getUserAdvancedStore().userData.get(userId).username;
  const userUUID = getUserAdvancedStore().userData.get(userId).userUUID;
  const isValidUserName = textGuard.isValidUserName({ userName: newName });
  if (!isValidUserName) {
    getCorePopUpStore().showAlertMessage("USER_NAME_CONDITIONS");
    return;
  }
  if (newName === oldName) {
    getCorePopUpStore().showAlertMessage("SAME_USER_NAME");
    return;
  }
  getCoreUIStore().setIsLoading("USER_ADVANCED", true);
  const adminUserId = getCorePersonalStore().user.get().id;
  const { status, code, data } = await apiCallChangeUserName({
    adminUserId,
    userUUID,
    oldUsername: oldName,
    newUsername: newName
  });
  getCoreUIStore().setIsLoading("USER_ADVANCED", false);
  if (status === "OK") {
    const newServerName = data;
    if (isDefinedString(newServerName)) {
      const oldUserData = getUserAdvancedStore().userData.get(userId);
      const newUserData = Object.assign(oldUserData, {
        username: newServerName
      });
      getUserAdvancedStore().userData.set(userId, newUserData);
    }
    getCorePopUpStore().showSuccessMessage("USER_NAME_CHANGED_SUCCESSFULLY");
  } else {
    getCorePopUpStore().showAlertMessage(code);
  }
};
export default changeUsernameOnDatabase;
